import { UserPreferences } from '@weblite/ts-action/user-preferences'
import { createKeyvalStorage, createKeyvalView } from '../lib/keyval.storage'

const key = 'user-preferences'

export const userPreferencesStorage = createKeyvalStorage<UserPreferences>(key)

export const userPreferencesView = createKeyvalView<UserPreferences>(key)
